import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { useTranslation } from 'react-i18next';
import { MyFreelancerSection } from '../../components/my-freelancer-section.component';
import { useState } from 'react';


function MyFreelancer() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar 
                activeItemId='freelancers'
                footer={null}
                onClose={() => setIsSidebarOpen(false)}
                className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <div className="dashboard-main-content">
                    <Header
                    setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='px-3'>
                        {/* <div>
                            <h1 className="dashboard-page__title mb-0">{t('MY_FREELANCERS')}</h1>
                        </div> */}
                        <MyFreelancerSection
                            className="invoices-section"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default MyFreelancer;
